import { render, staticRenderFns } from "./JobFamilyIcon.vue?vue&type=template&id=af36f864&scoped=true"
import script from "./JobFamilyIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./JobFamilyIcon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JobFamilyIcon.vue?vue&type=style&index=0&id=af36f864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af36f864",
  null
  
)

export default component.exports